// ─── Auth Service — Frontend ──────────────────────────────────────────────────

const WORKER_URL = process.env.REACT_APP_WORKER_URL || '';
const USER_KEY   = 'sirus_user';

export function getStoredToken() {
  return localStorage.getItem('sirus_token');
}

export function getStoredUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; }
}

export function storeSession(token, user) {
  // SA-012B: sirus_token non salvato — il JWT vive nel cookie HttpOnly impostato dal backend.
  // Salviamo solo sirus_user per mostrare l'UI immediatamente al reload senza flash di login.
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

// Chiavi device-level da preservare al logout (preferenze non legate all'utente)
const PRESERVE_ON_LOGOUT = new Set(['sirus_lang']);

export async function clearSession() {
  const toRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith('sirus_') && !PRESERVE_ON_LOGOUT.has(k)) toRemove.push(k);
  }
  toRemove.forEach(k => localStorage.removeItem(k));
  if (WORKER_URL) {
    try {
      await fetch(`${WORKER_URL}/api/auth/logout`, {
        method:      'POST',
        credentials: 'include',
      });
    } catch {}
  }
}

export async function login(username, password) {
  const r = await fetch(`${WORKER_URL}/api/auth/login`, {
    method:      'POST',
    headers:     { 'Content-Type': 'application/json' },
    credentials: 'include',
    body:        JSON.stringify({ username, password }),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.error || 'Login fallito');
  storeSession(data.token, data.user);
  return data;
}

export async function register(username, password) {
  const r = await fetch(`${WORKER_URL}/api/auth/register`, {
    method:      'POST',
    headers:     { 'Content-Type': 'application/json' },
    credentials: 'include',
    body:        JSON.stringify({ username, password }),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.error || 'Registrazione fallita');
  return data;
}

export async function logout() {
  await clearSession();
  window.location.reload();
}

// Bearer fallback transitorio per sessioni pre-SA-012B (rimosso in SA-012C)
export function authHeaders() {
  const token = getStoredToken();
  return token ? { 'Authorization': `Bearer ${token}` } : {};
}

// Verifica sessione con il backend — ritorna utente se valido, null se non autenticato.
// Prova cookie HttpOnly (SA-012B) + Bearer legacy come fallback — usa cache locale se offline.
export async function checkSession() {
  if (!WORKER_URL) return getStoredUser();
  try {
    const r = await fetch(`${WORKER_URL}/api/auth/me`, {
      credentials: 'include',
      headers:     authHeaders(),
    });
    if (r.ok) {
      const data = await r.json();
      return data.user || null;
    }
    return null;
  } catch {
    return getStoredUser();
  }
}
